

















































import VueOptions from '@utils/VueOptions'
import TitlePatternUtility from '@utils/TitlePatternUtility'
import LoadingIndicator from '@components/LoadingIndicator'
import SyncIndicator from '@components/SyncIndicator'
import AudienceListingDetail from '@ui/AudienceListing/AudienceListingDetail'
import MiniCalendar from '@ui/Calendar/MiniCalendar'

settings =
  name: 'AudienceCreativeShow'

  resources:
    audience_listings:
      resourceName: 'audience_listing'
      slug: 'audience_creatives/:audienceCreativeId/audience_listings'
      params:
        limit: 1000
    audience_listing:
      resourceName: 'audience_listing'
      slug: 'audience_creatives/:audienceCreativeId/audience_listings/:selectedListingId'
      fetch: false

  vue:
    data: ->
      selectedListingId: null
      displayDetail: true

    components: {
      LoadingIndicator,
      AudienceListingDetail,
      MiniCalendar,
      SyncIndicator,
    }

    computed:
      listings: -> @audience_listings || []
      selectedListing: -> @audience_listing

      displaySyncIndicator: ->
        @selectedListing?.marked_for_sync || @selectedListing?.marked_as_syncing

      optionsForCalendar: ->
        selectable: false
        dayCellClassNames: @dayCellClassNames

    methods:
      hiClose: -> @$router.back()

      hiChangeListing: (listingId) ->
        @displayDetail = false
        setTimeout((() => @displayDetail = true), 300)

      formatListingLabel: (listing) ->
        TitlePatternUtility.formatListingTitle listing

      formatListingOption: (listing) ->
        isSyncing = listing.marked_for_sync || listing.marked_as_syncing
        label = @formatListingLabel listing
        label = "#{label} <i class=\"fas fa-circle sync-label-indicator\"></i>" if isSyncing
        label

      dayCellClassNames: ({ date, isPast, ...args }) ->
        ['disabled']

      onLoadCollectionCompleted: (resourceKey) ->
        if resourceKey is 'audience_listings'
          @selectedListingId = @listings[0].id

      onLoadItemCompleted: (resourceKey, { item }) ->
        if resourceKey is 'audience_listing'
          if item.marked_for_sync || item.marked_as_syncing
            @triggerResource 'audience_listing', 'sync'

    watch:
      selectedListingId: (id) ->
        @fetch 'audience_listing'

export default VueOptions.vue settings
